import RequestSupportApplyComponent from "../../components/request-support/request-support-apply copy";

const RequestSupportApplyPage = () => {
    return (
        <RequestSupportApplyComponent />
    )
}

export default RequestSupportApplyPage;